



















import { Component, Prop, Vue } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
import Login from "@/views/Login.vue";
import Dashboard from '@/views/Dashboard.vue';
import Report from '@/views/Report.vue';
import { ClientState } from '@/core/ClientState';
import { Settings } from '@/core/Settings';
import { FView } from '@/core/FView';
import { Common } from '@/core/Common';
import { DataPeriod } from '@/core/data/DataPeriod';
import { Base64 } from 'js-base64';
import { ReportConfig } from '@/core/ReportConfig';

@Component({
  components: {
    Loading,
    Login,
    Dashboard,
    Report,
  }
})
export default class App extends Vue {
  public static REPORT_TOKEN: string = "__report__";

  private clientState = ClientState.NotLoaded;
  private globalError: string | null = null;
  private errorTimeoutHandle: number = 0;
  private reportView: Vue | null = null;

  checkReportView() {
    let hash = Common.GetHash();
    if (hash.length > 0) {
      let tokens = hash.split("|");
      if (tokens[0] == "__report__") {
        let confBase64 = tokens[1];
        let json = Base64.decode(confBase64);
        let conf = JSON.parse(json) as ReportConfig;
        
        FView.Get().dataManager.LoadData(new DataPeriod(conf.from, conf.to), conf.company, conf.user, true, conf.place)
          .then(_ => this.clientState = ClientState.ReportView)
          .catch(ex => { this.showError(ex); this.SwitchLoginState(); })
        
        return true;
      }
    }
    return false;
  }

  isLoading() { return this.clientState == ClientState.NotLoaded; }
  isNotLoggedIn() { return this.clientState == ClientState.NotLoggedIn; }
  isReady() { return this.clientState == ClientState.Ready; }
  isReportView() { return this.clientState == ClientState.ReportView; }

  isErrorVisible() { return this.globalError != null; }

  public showError(text:string) {
    this.hideError();
    this.globalError = text;
    this.errorTimeoutHandle = setTimeout(this.hideError, Settings.ErrorTimeout);
  }

  public hideError() {
    if (this.errorTimeoutHandle != 0) {
      clearTimeout(this.errorTimeoutHandle);
      this.errorTimeoutHandle = 0;
      this.globalError = null;
    }
  }

  public SwitchLoadingState() {
    this.clientState = ClientState.NotLoaded;
  }

  public SwitchLoginState() {
    this.clientState = ClientState.NotLoggedIn;
    FView.Get().rawDataManager.ClearData();
  }

  public SwitchDashboardState() {
    this.SwitchLoadingState();

    FView.Get().dataManager.LoadData()
      .then(_ => this.SwitchReadyState())
      .catch(ex => { this.showError(ex); this.SwitchLoginState(); })
  }

  public SwitchReadyState() {
    this.clientState = ClientState.Ready;
  }

  created() {
    if (!this.checkReportView()) {
      FView.Get().authManager.CheckAuth()
        .then(r => {
          if (r) {
            this.SwitchDashboardState();
          } else {
            this.SwitchLoginState();
          }
        })
        .catch(ex => { console.log(ex); this.SwitchLoginState(); });
    }
  }
}
